import {
  ERROR_BUSINESS_LANDING_DESCRIPTION,
  ERROR_BUSINESS_PAGE_CONTENT,
  ERROR_SME_BUSINESS_LANDING_DESCRIPTION,
  ERROR_SME_BUSINESS_PAGE_CONTENT,
  LOADING_BUSINESS_LANDING_DESCRIPTION,
  LOADING_BUSINESS_PAGE_CONTENT,
  LOADING_SME_BUSINESS_LANDING_DESCRIPTION,
  LOADING_SME_BUSINESS_PAGE_CONTENT,
  SUCCESS_BUSINESS_LANDING_DESCRIPTION,
  SUCCESS_BUSINESS_PAGE_CONTENT,
  SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION,
  SUCCESS_SME_BUSINESS_PAGE_CONTENT,
} from '../../const/actionTypes';
import { IIntelligenceSolutionBusinessPageItem } from '../../interfaces/IntelligenceSolutionBusinessPageItem';
import { ILandingPageDescriptionItem } from '../../interfaces/LandingPageDescriptionItem';

interface IInitialState {
  isLoading: boolean;
  businessLandingDescription: ILandingPageDescriptionItem[];
  smeBusinessLandingDescription: ILandingPageDescriptionItem[];
  businessPageContent: IIntelligenceSolutionBusinessPageItem[];
  smeBusinessPageContent: IIntelligenceSolutionBusinessPageItem[];
}

const initialState: IInitialState = {
  isLoading: false,
  businessLandingDescription: [],
  smeBusinessLandingDescription: [],
  businessPageContent: [],
  smeBusinessPageContent: [],
};

export type IntelligenceSolutionState = Readonly<typeof initialState>;

const intelligenceSolutionReducer = (
  state = initialState,
  action: any
): IntelligenceSolutionState => {
  switch (action.type) {
    case LOADING_BUSINESS_LANDING_DESCRIPTION:
    case LOADING_BUSINESS_PAGE_CONTENT:
    case LOADING_SME_BUSINESS_PAGE_CONTENT:
    case LOADING_SME_BUSINESS_LANDING_DESCRIPTION: {
      return {
        ...state,
        isLoading: true,
      };
    }

    // business landing page description
    case SUCCESS_BUSINESS_LANDING_DESCRIPTION: {
      return {
        ...state,
        isLoading: false,
        businessLandingDescription: action.payload,
      };
    }

    // business landing page content
    case SUCCESS_BUSINESS_PAGE_CONTENT: {
      return {
        ...state,
        isLoading: false,
        businessPageContent: action.payload,
      };
    }

    // sme business landing page description
    case SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION: {
      return {
        ...state,
        isLoading: false,
        smeBusinessLandingDescription: action.payload,
      };
    }

    // sme business landing page content
    case SUCCESS_SME_BUSINESS_PAGE_CONTENT: {
      return {
        ...state,
        isLoading: false,
        smeBusinessPageContent: action.payload,
      };
    }

    case ERROR_BUSINESS_PAGE_CONTENT:
    case ERROR_BUSINESS_LANDING_DESCRIPTION:
    case ERROR_SME_BUSINESS_PAGE_CONTENT:
    case ERROR_SME_BUSINESS_LANDING_DESCRIPTION: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};

export default intelligenceSolutionReducer;
